













































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

import { isOfficialDomain, replaceURLWithCurrentDomain } from '@/web/utils/url';

export default Vue.extend({
  name: 'ViewAsTeacherFooter',
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
      interactAsStudio: 'community/interactAsStudio',
      studentCommunityProfileFirstName: 'user/studentCommunityProfileFirstName',
    }),
    ...mapState('user', ['teacher']),
    asStudio: {
      get() {
        return !this.interactAsStudio;
      },
      set(newValue: boolean) {
        this.$store.dispatch('community/setInteractAsStudio', !newValue);
      },
    },
    getBaseFrontendURL() {
      const host = window.location.host.toLowerCase();
      if (isOfficialDomain(host)) {
        return replaceURLWithCurrentDomain(window.location.origin);
      }

      return process.env.VUE_APP_FRONTEND_BASE_URL;
    },
    dashboardLink() {
      return `${this.getBaseFrontendURL}dashboard?magic_code=${this.teacherMagicCode}`;
    },
    showViewAsTeacherFooter() {
      return (
        this.teacher &&
        this.teacherStudioUrl === this.studio?.studio_url &&
        !this.$route.meta.hideStudioAdminFooter
      );
    },
  },
});
